import './App.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { SiteHeader } from './components/layout/SiteHeader'
import { SiteFooter } from './components/layout/SiteFooter'
import { ScrollToHash } from './components/layout/ScrollToHash'
import { Hero } from './components/features/Hero'
import { VideoShowcase } from './components/features/VideoShowcase'
import { ValueProps } from './components/features/ValueProps'
import { ScreenShare } from './components/features/ScreenShare'
import { FeaturesGrid } from './components/features/FeaturesGrid'
import { CallToAction } from './components/features/CallToAction'
import SignUp from './components/SignUp'
import SignIn from './components/SignIn'
import Dashboard from './components/Dashboard'
import PrivacyPolicy from './components/legal/PrivacyPolicy'
import Terms from './components/legal/Terms'
import Impressum from './components/legal/Impressum'
import DeleteAccount from './components/DeleteAccount'
import NotFound from './components/NotFound'

function HomePage() {
  return (
    <>
      <Hero />
      <VideoShowcase />
      <ValueProps />
      <ScreenShare />
      <FeaturesGrid />
      <CallToAction />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToHash />
        <div className="app">
          <SiteHeader />

          <main className="app-main">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>

          <SiteFooter />
        </div>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App
